import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import userAction from "../actions/User";
import "../styles/header.css";
import { SYSTEM_CONSTANTS } from "../types";
import app_logo from "../assets/app_logo.png";
import { useOktaAuth } from '@okta/okta-react';
import { Mail, User, Award, Home } from "react-feather";
import { ISSUER } from "../creds";
import BondRegistrationContext from "../store/BondRegistrationContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { bondRegistrationContextData, setBondRegistrationContextData } = useContext(BondRegistrationContext);
  const [userInformation, setInformation] = useState(null);
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userLawFirm, setUserLawFirm] = useState("");
  const { oktaAuth, authState } = useOktaAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);



  useEffect(() => {

    setInformation(user.userinfo)

  }, [user]);

  useEffect(() => {
    if (userInformation) {
      setUserName(userInformation?.uname);
      setUserRole(userInformation?.role);
      setUserEmail(userInformation?.email);
      setUserLawFirm(userInformation?.law_firm)
    }

  }, [userInformation]);

  const handleCloseLogoutModal = () => {
    setShowLogoutModal(false);

  }

  const handleYesConfirmation = () => {
    setShowLogoutModal(false);
    clickLogout()
    navigate("/logout-successful");

  }

  async function oktaLogout() {
    try {
      await oktaAuth.signOut({
        postLogoutRedirectUri: `${window.location.origin}/logout-successful`,
        clearTokensBeforeRedirect: true
      });
    } catch (error) {
      console.error('Sign out error:', error);
    }
  }



  async function clickLogout() {
    try {
      // Clear tokens from Okta’s token manager
      await oktaLogout()
      oktaAuth.tokenManager.clear();

      // Revoke tokens
      await Promise.all([
        oktaAuth.revokeRefreshToken(),
        oktaAuth.revokeAccessToken(),
      ]);

      // Clear browser storage
      localStorage.clear();
      sessionStorage.clear();
      setBondRegistrationContextData(null);

      // Update app’s state to reflect user logged out
      dispatch(userAction.logoutUser());

      // Define where to send the user after a successful logout
      const postLogoutRedirectUri = `${window.location.origin}/logout-successful`;

      // Close the Okta session and sign out
      await oktaAuth.signOut();

      // At this point, the user is redirected to /login.
      // To be absolutely sure they are logged out, you can perform a post-check on the /login page:

      // On the /login page, add a similar check:
      // (This might be in a useEffect hook or some initialization code of your login page)
      const isAuthenticated = await oktaAuth.isAuthenticated();
      if (isAuthenticated) {
        console.warn('User still appears authenticated. Retrying logout...');
        await oktaAuth.signOut({ postLogoutRedirectUri });
      } else {
        console.log('User successfully logged out of both app and Okta session.');
      }

    } catch (error) {
      console.error('Logout failed:', error);
    }
  }


  return (
    <div className="container-fluid">
      <nav className="navbar navbar-dark px-4" style={{ color: 'white' }}>
        <div className="navbar-child-box">
          <NavLink to="/" className={"navbar-brand"}>
            <img src={app_logo} alt="Logo" style={{ maxHeight: '80px', maxWidth: '100px' }} />
          </NavLink>
          <div className="navbar-child-box">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
              <li className="app-header-title">
                <a className="title-link" href="/">
                  <label>{SYSTEM_CONSTANTS.SYSTEM_NAME}</label>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mx-2 right-container">
          {/* <div className="d-flex align-items-center">
            <NavLink className="nav-link px-2 app-nav-link d-flex align-items-center" to={"/"}>
              Home
            </NavLink>
          </div> */}
          {/* <li>
            <NavLink className="nav-link px-2" to={"/report"}>
            Reports
            </NavLink>
            </li> */}
          <span className="d-flex align-items-center app-user">{userName}</span>
          <Dropdown className="nav-item avatar" align="end">
            <span className="d-inline-block d-sm-none">
              <Dropdown.Toggle as="a" className="nav-link">
                <FontAwesomeIcon icon={faUserAlt} size={18} className="align-middle" />
              </Dropdown.Toggle>
            </span>
            <span className="d-none d-sm-inline-block">
              <Dropdown.Toggle as="a" className="nav-link avatar-logo">
                <FontAwesomeIcon icon={faUserAlt} size={18} className="align-middle" />
              </Dropdown.Toggle>
            </span>
            <Dropdown.Menu drop="end">
              <Dropdown.Item>
                <User size={18} className="align-middle me-2" />
                {userName}
              </Dropdown.Item>
              <Dropdown.Item>
                <Mail size={18} className="align-middle me-2" />
                {userEmail}
              </Dropdown.Item>
              <Dropdown.Item>
                <Award size={18} className="align-middle me-2" />
                {"Role: " + userRole}
              </Dropdown.Item>
              {userRole === "CSL" && (
                <Dropdown.Item>
                  <Home size={18} className="align-middle me-2" />
                  {"Law Firm: " + userLawFirm}
                </Dropdown.Item> 
              )}
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => handleYesConfirmation()}>Sign out</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* <FontAwesomeIcon icon={faPowerOff} onClick={() => clickLogout()} size="lg" title="Logout" /> */}

        </div>

      </nav>
      <Modal
        show={showLogoutModal}
        onHide={handleCloseLogoutModal}>
        <Modal.Header closeButton>
          <h2>
            Logout
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div>
            Confirm Logout <br />
            <br />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-container" style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              type="button"
              class="btn btn-primary"
              onClick={() => handleCloseLogoutModal()}
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              onClick={() => handleYesConfirmation()}
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Header;
